// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex } from '@iheartjane/reefer';
import { mediaQueries, spacing } from '@iheartjane/reefer-emotion';

import {
  DESKTOP_PADDING_HORIZONTAL,
  MOBILE_PADDING_HORIZONTAL,
  PADDING_VERTICAL,
} from '../pendingCartDrawer.styles';

export const SummaryWrapper = styled(Flex)(({ theme }) => ({
  ...spacing({ px: MOBILE_PADDING_HORIZONTAL, py: PADDING_VERTICAL }),
  [mediaQueries.tablet('min')]: {
    ...spacing({ px: DESKTOP_PADDING_HORIZONTAL }),
  },
  backgroundColor: theme.colors.grays.white,
}));
